module.exports = __webpack_public_path__ + "img/bg.b2624b0.png";